module.exports = __webpack_public_path__ + "img/retired-2012-group.106f71ce.jpg";